module.exports = __webpack_public_path__ + "assets/home-min.a0f1af0f0b752c55f9251e7475f07ef3.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/MVEVA/home-min.jpg
 ** module id = 387
 ** module chunks = 0
 **/